import React,{useState} from 'react'
import clsx from 'clsx'
import type {Dispatch, FC} from 'react'
import {Link} from 'react-router-dom'
import getPageList from '../../../utils/getPageList'
import getValueFromObj from '../../../utils/getValueFromObj'
import ModalDelete from '../../sections/ModalDeleteDialog'

interface Props {
  head: string[]
  body: Array<string | {text: string; truncate?: number}>
  data: Array<any> | undefined
  isWithAction?: boolean
  href?: string
  customBtnAction?: string
  customBtnActionProps?: any
  customBtnOnClickWithId?: Dispatch<React.SetStateAction<number>>
  isCustomBtnActionLink?: boolean
  handleDelete?: (e: any) => void
  showEdit?: boolean
  allPaginate?: number
  page?: number
  setsPage?: (e: any) => void
  nextPage?: () => void
  prevPage?: () => void
  loadings?: boolean
  texts?: string
}

const TableDefault: FC<Props> = ({
  head,
  body,
  data,
  isWithAction = true,
  href,
  customBtnActionProps,
  customBtnOnClickWithId,
  isCustomBtnActionLink,
  handleDelete,
  showEdit,
  allPaginate = null,
  page,
  setsPage,
  nextPage,
  prevPage,
  customBtnAction,
  loadings,
  texts,
}) => {
  const [id, setId] = useState(0)
  const pageNumbers = getPageList(allPaginate!, page!, 9)
  return (
    <div className='p-8'>
      {data?.length !== 0 ? (
        <>
          <table className='table table-hover table-rounded table-striped border gy-7 gs-7'>
            <thead>
              <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                {head.map((item, index) => (
                  <th key={index}>{item}</th>
                ))}
                {isWithAction && <th className='text-end'>Action</th>}
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={index}>
                  {body.map((obj, i) => (
                    <td key={i}>
                      {getValueFromObj(typeof obj === 'string' ? obj : obj.text, item)
                        ?.toString()
                        .substring(0, typeof obj === 'string' ? undefined : obj?.truncate)}
                      {typeof obj !== 'string' && obj?.truncate ? '...' : ''}
                    </td>
                  ))}
                  {isWithAction &&
                    (customBtnAction ? (
                      <td className='d-flex justify-content-end gap-4 text-end'>
                        {isCustomBtnActionLink ? (
                          <Link to={`/${href}/${item.id}`}>
                            <button className='btn btn-sm btn-light-primary'>
                              {customBtnAction}
                            </button>
                          </Link>
                        ) : (
                          <button
                            {...customBtnActionProps}
                            onClick={
                              customBtnOnClickWithId
                                ? () => customBtnOnClickWithId(item.attributes?.member?.data?.id)
                                : undefined
                            }
                            className='btn btn-sm btn-light-primary'
                          >
                            {customBtnAction}
                          </button>
                        )}
                      </td>
                    ) : (
                      <td className='d-flex gap-4 justify-content-end text-end'>
                        {
                           href !== 'redemptions' &&  <Link to={`/${href}update/${item.id}`}>
                           <button className='btn btn-sm btn-light-primary'>
                             <i className='bi bi-pencil'></i>
                           </button>
                         </Link>
                        }
                       
                        {showEdit && (
                          <Link to={`/${href}detail/${item.id}`}>
                            <button className='btn btn-sm btn-light-primary'>
                              <i className='bi bi-binoculars'></i>
                            </button>
                          </Link>
                        )}
                        {!loadings ? (
                          href !== 'transaction' ? (<button
                          className='btn btn-sm btn-light-danger'
                          data-bs-toggle='modal'
                          data-bs-target='#delete-modal'
                          onClick={() =>{ 
                            setId(item.id)
                          }}
                        >
                          <i className={'bi bi-trash'}></i>
                        </button> ):
                         ( <button
                            className='btn btn-sm btn-light-danger'
                            onClick={() =>{ 
                              if(href === 'transaction'){
                                handleDelete?.(item)
                              }else{
                                handleDelete?.(item.id)
                              }
                            }}
                          >
                            <i className={ href === 'transaction' ? 'bi bi-book' : 'bi bi-trash'}></i>
                          </button>)
                        ) : (
                          <button 
                            className='btn btn-sm btn-light-danger align-item-center'
                            data-kt-indicator='on'
                            type='button'
                          >
                           <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </button>
                        )}
                      </td>
                    ))}

                </tr>
              ))}
             
            </tbody>
          </table>
          <ul className='pagination'>
            <li className='page-item previous'>
              <button
                className='page-link'
                onClick={() => (page === -1 || page === 0 ? null : prevPage!())}
                disabled={page === 1 || page === 0 && true}
              >
                <i className='previous'></i>
              </button>
            </li>
            {pageNumbers.map((num, i) =>
              num === 0 ? (
                <li key={i} className='page-item'>
                  <button className='page-link'>...</button>
                </li>
              ) : (
                <li
                  className={clsx('page-item', {
                    active: page === num,
                  })}
                  key={i}
                >
                  <button
                    className='page-link'
                    onClick={() => {
                      setsPage?.(num)
                    }}
                  >
                    {num}
                  </button>
                </li>
              )
            )}
            <li className='page-item next'>
              <button
                className='page-link'
                onClick={() =>  page! > pageNumbers.length ? null : nextPage!()}
                disabled={ page! >= pageNumbers.length && true}
              >
                <i className='next'></i>
              </button>
            </li>
          </ul>
        </>
      ) : (
        <h2 className='d-flex justify-content-center text-dark m-5'>Data Not Found</h2>
      )}
     <ModalDelete text={texts} id={id} setStates={setId} handleClick={ handleDelete} />
    </div>
  )
}

export default TableDefault
